import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file-find.dto';
import { DocumentLinkComponent } from '@zaoblako/web/shared/components/document-link/document-link.component';
import { GalleriaComponent } from '@zaoblako/web/shared/dumbs/galleria/galleria.component';
import { ImageComponent } from '@zaoblako/web/shared/dumbs/image/image.component';
import { ApiUrlPipe } from '@zaoblako/web/shared/pipes/api-url.pipe';
import { OrderByPipe } from '@zaoblako/web/shared/pipes/order-by.pipe';

@Component({
  standalone: true,
  selector: 'crm-files-list',
  templateUrl: 'files-list.component.html',
  imports: [CommonModule, DocumentLinkComponent, OrderByPipe, ApiUrlPipe, ImageComponent, GalleriaComponent],
  providers: [ApiUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilesListComponent implements OnChanges {
  @Input() public files: FileFindInterface[];
  @Input() public canDelete = false;

  @Output() public deleteFile = new EventEmitter<FileFindInterface>();

  public visible = false;
  public images: { id: string; src: string; alt: string }[] = [];
  public activeImageIndex: number;

  public constructor(private readonly apiUrlPipe: ApiUrlPipe) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.files?.currentValue) {
      this.images = this.files
        .filter((file) => file.mime.includes('image/'))
        .map((image) => ({ id: image.path, src: this.apiUrlPipe.transform(`file/${image.path}`), alt: image.name }));
      this.activeImageIndex = 0;
    }
  }

  public clickDeleteFile(file: FileFindInterface) {
    this.files = this.files.filter((_file) => _file.id !== file.id);
    this.images = [
      ...this.files
        .filter((file) => file.mime.includes('image/'))
        .map((image) => ({ id: image.path, src: this.apiUrlPipe.transform(`file/${image.path}`), alt: image.name }))
    ];
    this.activeImageIndex = 0;
    this.deleteFile.emit(file);
  }

  public clickImage(image: FileFindInterface) {
    this.activeImageIndex = this.images.findIndex((_image) => _image.id === image.path);
    this.visible = true;
  }
}
